<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-row-group :theme="$otTheme" :code="code">
            <ot-title-tip :theme="$otTheme" content="这是我们的官网">
                <span>www.zyao89.cn</span>
            </ot-title-tip>
            <ot-title-tip :theme="$otTheme" content="没有箭头" :arrow="false">
                <span>无箭头指示</span>
            </ot-title-tip>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-title-tip%20content%3D%22%E8%BF%99%E6%98%AF%E6%88%91%E4%BB%AC%E7%9A%84%E5%AE%98%E7%BD%91%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cspan%3Ewww.zyao89.cn%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-title-tip%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-title-tip%20content%3D%22%E6%B2%A1%E6%9C%89%E7%AE%AD%E5%A4%B4%22%20%3Aarrow%3D%22false%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cspan%3E%E6%97%A0%E7%AE%AD%E5%A4%B4%E6%8C%87%E7%A4%BA%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-title-tip%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E`),
        };
    },
};
</script>
